import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { DatePicker as VCalendarDatePicker } from "v-calendar";
import "v-calendar/dist/style.css";
import {
  computed,
  reactive,
  watch,
  PropType,
} from "vue";
import type {
  DatePickerDate,
  DatePickerRangeObject,
} from "v-calendar/dist/types/src/use/datePicker";


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
  modelValue: {
    type: [Date, Object] as PropType<
      DatePickerDate | DatePickerRangeObject | null
    >,
    default: null,
  },
},
  emits: ["update:model-value", "close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const date = computed({
  get: () => props.modelValue,
  set: (value: unknown) => {
    emit("update:model-value", value);
    emit("close");
  },
});

const attrs = reactive({
  color: "primary",
  "is-dark": false,
  "first-day-of-week": 1,
});

function onDayClick(_: unknown, event: MouseEvent): void {
  const target = event.target as HTMLElement;
  if (target) target.blur();
}

function isDatePickerRangeObject(
  value: DatePickerDate | DatePickerRangeObject | null
): value is DatePickerRangeObject {
  return (
    !!value && typeof value === "object" && "start" in value && "end" in value
  );
}

watch(
  () => props.modelValue,
  (newValue) => {
    console.log("modelValue changed:", newValue);
  }
);

return (_ctx: any,_cache: any) => {
  return (isDatePickerRangeObject(date.value))
    ? (_openBlock(), _createBlock(_unref(VCalendarDatePicker), _mergeProps({
        key: 0,
        modelValue: date.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
        modelModifiers: { range: true }
      }, { ...attrs, ..._ctx.$attrs }, { onDayclick: onDayClick }), null, 16, ["modelValue"]))
    : (_openBlock(), _createBlock(_unref(VCalendarDatePicker), _mergeProps({
        key: 1,
        modelValue: date.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event))
      }, { ...attrs, ..._ctx.$attrs }, { onDayclick: onDayClick }), null, 16, ["modelValue"]))
}
}

})